module.exports = __webpack_public_path__ + "static/media/img-raffle-info-2.6cee05e8.png";